module.exports = __webpack_public_path__ + "img/logoLogin.8aab008a.png";